import React, { useState, useEffect } from "react";
import TextWave from "../TextWave"; // Animovaný nadpis
import styles from "./HeroSection.module.css"; // CSS modul
import { Helmet } from "react-helmet";

const HeroSection = ({ height, scrollWrapperRef }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoaded(true);
        }, 100); // nebo 50–200 ms podle potřeby

        return () => clearTimeout(timeout);
    }, []);


    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
            window.history.pushState(null, "", `#${id}`);
        }
    };



    return (
        <>
        {/* Levá část s TextWave */}
            <Helmet>
                <link rel="preload" as="image" href="/hero.webp" fetchpriority="high" />
            </Helmet>
            <div
                className={styles.visuallyHidden}
                dangerouslySetInnerHTML={{
                    __html: '<h1>Tetovací studio Jakub Vychodil Art – Tetování Moravské Budějovice | Znojmo | Třebíč | Jemnice  | Dačice | Jihlava</h1>'
                }}
            />

        <div className={styles.left}>
            <TextWave scrollWrapperRef={scrollWrapperRef} loaded={loaded} />
            <div className={`${styles.buttons} ${loaded ? styles.loaded : ""}`}>
                <button className={`${styles.primaryButton} ${styles.buttonHero}`} onClick={() => scrollToSection("voucher")}>
                    <img width="54" height="55" src="/icon _arrow_right.svg" alt="Scroll to voucher" loading="eager" fetchpriority="high" className={styles.buttonIcon} />
                    VOUCHER
                </button>
                <button className={`${styles.primaryButton} ${styles.buttonHero}`} onClick={() => scrollToSection("contact")}>
                    <img width="54" height="55" src="/icon _arrow_right.svg" alt="Scroll to contact" loading="eager" fetchpriority="high" className={styles.buttonIcon} />
                    KONTAKT
                </button>
            </div>
        </div>

        {/* Pravá část s hlavním obrázkem */}
        <div className={styles.right}>
            <div className={styles.imgContainer}>
                <img src="/hero.webp" alt="Jakub jak tetuje" width="888" height="888"  loading="eager" fetchpriority="high"  className={`${styles.mainImage} ${loaded ? styles.loaded : ""}`} />
                <div className={styles.gradient}></div>
            </div>
        </div>

        {/* Obrázek v pravém dolním rohu */}
        <img  width="617" height="536"  src="/ruze.svg" alt="Dekorativní motiv růže – Jakub Vychodil Art" loading="eager" fetchpriority="high" className={`${styles.bottomImage} ${loaded ? styles.loaded : ""}`}/>
        </>
    );
};

export default HeroSection;
